/**
 * Normalizes an unknown error-like input to a plain object for safe inclusion in Sentry extras.
 * - Error => selected safe fields (name, message, stack)
 * - Plain object => shallow clone
 * - Primitive => wrapped under { value }
 */
export function normalizeUnknownForExtras(
  err: unknown
): Record<string, unknown> | undefined {
  if (!err) return undefined;
  if (err instanceof Error) {
    return {
      name: err.name,
      message: err.message,
      stack: err.stack,
    };
  }
  if (typeof err === 'object') {
    return { ...err } as Record<string, unknown>;
  }
  return { value: err };
}
